import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'

import {
    Caveat,
    Geist_Mono,
    Great_Vibes,
    Nunito,
    Playfair_Display
} from 'next/font/google'

const sans = Nunito({
    subsets: ['latin']
})

const mono = Geist_Mono({
    subsets: ['latin']
})

const heading = Playfair_Display({
    subsets: ['latin'],
    style: ['normal', 'italic']
})

const script = Great_Vibes({
    subsets: ['latin'],
    weight: '400'
})

const hand = Caveat({
    subsets: ['latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily};--font-app-script:${script.style.fontFamily};--font-app-hand:${hand.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
